var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.964 212.06C162.269 219.901 146.912 224.39 131.15 225.158C115.388 225.927 99.6672 222.955 85.2738 216.484C70.8804 210.013 58.2227 200.228 48.3358 187.928C38.4488 175.628 31.6133 161.163 28.388 145.715L55.8899 139.973C58.209 151.081 63.1241 161.482 70.2334 170.326C77.3426 179.171 86.4441 186.207 96.7937 190.86C107.143 195.513 118.447 197.65 129.781 197.097C141.115 196.544 152.157 193.317 162.005 187.678L175.964 212.06Z",
    fill: "url(#paint0_linear_360_2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_360_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 132C66 148.016 53.0163 161 37 161C20.9837 161 8 148.016 8 132C8 115.984 20.9837 103 37 103C53.0163 103 66 115.984 66 132ZM25.5781 132C25.5781 138.308 30.6919 143.422 37 143.422C43.3081 143.422 48.4219 138.308 48.4219 132C48.4219 125.692 43.3081 120.578 37 120.578C30.6919 120.578 25.5781 125.692 25.5781 132Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 132C66 148.016 53.0163 161 37 161C20.9837 161 8 148.016 8 132C8 115.984 20.9837 103 37 103C53.0163 103 66 115.984 66 132ZM25.5781 132C25.5781 138.308 30.6919 143.422 37 143.422C43.3081 143.422 48.4219 138.308 48.4219 132C48.4219 125.692 43.3081 120.578 37 120.578C30.6919 120.578 25.5781 125.692 25.5781 132Z",
    stroke: "#80E614",
    strokeWidth: 20,
    mask: "url(#path-2-inside-1_360_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.036 38.4946C90.7312 30.6535 106.088 26.165 121.85 25.3961C137.612 24.6271 153.333 27.5995 167.726 34.0703C182.12 40.5411 194.777 50.3265 204.664 62.6265C214.551 74.9264 221.387 89.3917 224.612 104.84L197.11 110.582C194.791 99.4737 189.876 89.0725 182.767 80.2281C175.657 71.3838 166.556 64.3476 156.206 59.6948C145.857 55.042 134.553 52.9047 123.219 53.4576C111.885 54.0105 100.843 57.238 90.9954 62.8761L77.036 38.4946Z",
    fill: "url(#paint1_linear_360_2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_360_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 118.555C187 102.538 199.984 89.5545 216 89.5545C232.016 89.5545 245 102.538 245 118.555C245 134.571 232.016 147.555 216 147.555C199.984 147.555 187 134.571 187 118.555ZM227.422 118.555C227.422 112.246 222.308 107.133 216 107.133C209.692 107.133 204.578 112.246 204.578 118.555C204.578 124.863 209.692 129.976 216 129.976C222.308 129.976 227.422 124.863 227.422 118.555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187 118.555C187 102.538 199.984 89.5545 216 89.5545C232.016 89.5545 245 102.538 245 118.555C245 134.571 232.016 147.555 216 147.555C199.984 147.555 187 134.571 187 118.555ZM227.422 118.555C227.422 112.246 222.308 107.133 216 107.133C209.692 107.133 204.578 112.246 204.578 118.555C204.578 124.863 209.692 129.976 216 129.976C222.308 129.976 227.422 124.863 227.422 118.555Z",
    stroke: "#80E614",
    strokeWidth: 20,
    mask: "url(#path-4-inside-2_360_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_2",
    x1: 47.1624,
    y1: 64.1148,
    x2: 205.392,
    y2: 186.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E614"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_2",
    x1: 205.838,
    y1: 186.44,
    x2: 47.6079,
    y2: 64.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E614"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting2);
export default __webpack_public_path__ + "static/media/waiting2.b2655d16597b722a07d97f1f7425fdce.svg";
export { ForwardRef as ReactComponent };